<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M22.41 21.3H11.57a2 2 0 01-1.93-1.48L6.15 7H4a1 1 0 010-2h2.15a2 2 0 011.93 1.48l.59 2.17h16.9a2 2 0 011.88 2.69L24.29 20a2 2 0 01-1.88 1.3zm-10.84-2h10.84l3.16-8.65H9.22zM12.75 25.18a.91.91 0 11-.91.91.91.91 0 01.91-.91m0-2a2.91 2.91 0 102.91 2.91 2.91 2.91 0 00-2.91-2.91zM21.17 25.18a.91.91 0 11-.91.91.91.91 0 01.91-.91m0-2a2.91 2.91 0 102.91 2.91 2.91 2.91 0 00-2.91-2.91z"/></svg>